import React from "react";
import { inject, observer } from "mobx-react";
import { injectIntl } from "react-intl";

import Editable from "./Editable";
import { TODO_ITEM_STATUSES } from "./constants";

@injectIntl
@inject("rootStore")
@observer
export default class TodoBody extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.canEdit = props.rootStore.authorizationStore.canEditTodo(props.note);
  }

  render() {
    const { item, note, intl } = this.props;

    return (
      <div
        className="note-todo-body-container"
        style={{ position: "relative" }}
      >
        <i
          className={`note-todo-icon ${this.faIconFromStatus(item.status)}`}
          aria-hidden="true"
          onClick={() => this.canEdit && note.toggleItemStatus(item)}
        />

        <Editable
          value={item.description}
          lineThrough={item.status === TODO_ITEM_STATUSES.DONE}
          canEdit={this.canEdit}
          canDelete={this.canEdit}
          showDelete
          onEdit={value => note.editTodoItem(item, value)}
          onDelete={() => note.deleteTodoItem(item)}
          showOptionButton
          optionButtonText={intl.formatMessage({ id: "convert_to_task" })}
          onOptionButtonClick={this.handleConvertToTaskButton}
        />
      </div>
    );
  }

  handleConvertToTaskButton = () => {
    const { rootStore, item, note } = this.props;

    if (!this.canEdit) {
      return;
    }

    if (rootStore.todoLaneStore) {
      rootStore.todoLaneStore.addNote({ name: item.description });
      note.deleteTodoItem(item);
    }
  };

  faIconFromStatus = status => {
    let faIconClass = "";
    switch (status) {
      case TODO_ITEM_STATUSES.DOING:
        faIconClass = "fa fa-refresh";
        break;
      case TODO_ITEM_STATUSES.DONE:
        faIconClass = "fa fa-check-circle-o";
        break;
      default:
        faIconClass = "fa fa-circle-o";
        break;
    }

    return faIconClass;
  };
}
